export const SEASONALITY_TYPE_YEAR = "YEAR";
export const SEASONALITY_TYPE_AVERAGE = "AVERAGE";
export const SEASONALITY_TYPE_CALCULATED_INDEX = "CALCULATED_INDEX";
export const SEASONALITY_TYPE_PROPOSED_INDEX = "PROPOSED_INDEX";
